import { useCurrentPostHelpers } from "@circle-react/components/PostsV3/useCurrentPostHelpers";
import { BlockInViewOnlyMode } from "@circle-react/components/ViewOnlyMasquerading/BlockInViewOnlyMode";
import { classNames } from "@circle-react/helpers/twMergeWithCN";

import { anchorClassNames } from "@/react/helpers/cssAnchorHelpers";

import { CommentsForm } from "./CommentsForm";
import { CommentsLink } from "./CommentsLink";
import { LikeButton } from "./LikeButton";

interface EngagementActionsProps {
  className?: string;
  shouldForceSamePageInteractions?: boolean;
  shouldOpenCommentPage?: boolean;
  showCommentAndFocusCommentForm: () => void;
  toggleComment: () => void;
}

export const EngagementActions = ({
  toggleComment,
  showCommentAndFocusCommentForm,
  shouldOpenCommentPage = false,
  shouldForceSamePageInteractions = false,
  className = "",
}: EngagementActionsProps) => {
  const { showEngagementActions: shouldShowActions } = useCurrentPostHelpers();

  if (!shouldShowActions) {
    return null;
  }

  return (
    <div
      className={classNames(
        anchorClassNames("post__actions post__actions-visible"),
        "border-primary flex items-center gap-1 border-0 px-3 pt-0 md:border-t md:px-4 md:py-2.5",
        className,
      )}
      data-testid="post-engagement-actions"
    >
      <BlockInViewOnlyMode>
        <LikeButton />
      </BlockInViewOnlyMode>

      <CommentsForm
        shouldOpenCommentPage={shouldOpenCommentPage}
        showCommentAndFocusCommentForm={showCommentAndFocusCommentForm}
        toggleComment={toggleComment}
        shouldForceSamePageInteractions={shouldForceSamePageInteractions}
      />
      <CommentsLink
        shouldOpenCommentPage={shouldOpenCommentPage}
        toggleComment={toggleComment}
      />
    </div>
  );
};
